import { IconInstagram, IconFacebook, IconLinkedin, IconYoutube } from '@lmig/lmds-react-icons';

export default function PLFooterSocial() {
  return (
    <>
      <a
        href="https://www.instagram.com/safeco.insurance/"
        aria-label="Visit Us on Instagram"
        target="_blank"
        rel="noopener noreferrer"
        data-action="action url"
        data-icon="icon-instagram"
      >
        <IconInstagram color="inverse" size="32" />
      </a>
      <a
        href="https://www.facebook.com/libertymutual"
        aria-label="Visit Us on Facebook"
        target="_blank"
        rel="noopener noreferrer"
        data-action="action url"
        data-icon="icon-facebook"
      >
        <IconFacebook color="inverse" size="32" />
      </a>
      <a
        href="https://www.linkedin.com/company/liberty-mutual-insurance"
        aria-label="Visit Us on LinkedIn"
        target="_blank"
        rel="noopener noreferrer"
        data-action="action url"
        data-icon="icon-linkedIn"
      >
        <IconLinkedin color="inverse" size="32" />
      </a>
      <a
        href="https://www.youtube.com/safecotv"
        aria-label="Visit Us on YouTube"
        target="_blank"
        rel="noopener noreferrer"
        data-action="action url"
        data-icon="icon-youtube"
      >
        <IconYoutube color="inverse" size="32" />
      </a>
    </>
  );
}
